/**
 * Module to add a shipping rates calculator to cart page inside Bootstrap modal
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under MIT and GPL licenses
 * Modified for Bootstrap modal integration, pure JavaScript, and province population
 */
if (typeof Countries === 'object') {
  Countries.updateProvinceLabel = function(country, element) {
    if (typeof country === 'string' && Countries[country] && Countries[country].provinces) {
      if (typeof element !== 'object') {
        element = document.getElementById('address_province_label');
        if (element === null) return;
      }
      element.innerHTML = Countries[country].label;
      const parent = element.parentElement;
      const select = parent.querySelector('select');
      if (select) {
        const inner = select.querySelector('.custom-style-select-box-inner');
        if (inner) {
          inner.innerHTML = Countries[country].provinces[0];
        }
      }
    }
  };
}

if (typeof Shopify === 'undefined') Shopify = {};
if (!Shopify.Cart) Shopify.Cart = {};

Shopify.Cart.ShippingCalculator = (function() {
  const _config = {
    submitButton: "Calculate Shipping",
    submitButtonDisabled: "Calculating...",
    templateId: "shipping-calculator-response-template",
    wrapperId: "wrapper-response",
    customerIsLoggedIn: false,
    moneyFormat: ""
  };

  const _populateProvinces = function(country, provinceSelect, defaultProvince) {
    if (Countries[country] && Countries[country].provinces) {
      provinceSelect.innerHTML = '';
      Countries[country].provinces.forEach(function(province) {
        const option = document.createElement('option');
        option.value = province;
        option.text = province;
        if (defaultProvince && province === defaultProvince) {
          option.selected = true;
        }
        provinceSelect.appendChild(option);
      });
    }
  };

  const _render = function(response) {
    const wrapper = document.getElementById('wrapper-response');
    console.log(response);
    if(wrapper) {
    if (response.rates && response.rates.length && response.success) {    
      let html = '<ul class="shipping-calculator-response">';
      response.rates.forEach(function(rate) {
        html += '<li>' + rate.name + ' ';
        html += '$' + rate.price +' '+ rate.currency+'</li>';
      })
      html += '</ul>';
     
    
        wrapper.innerHTML = html;
      }
    else if (response.error) {
      wrapper.innerHTML = '<div class="error">' + response.error + '</div>';
    }
  }
  
  };

  return {
    show: function(params) {
      Object.assign(_config, params);
      document.addEventListener('DOMContentLoaded', function() {
        const countrySelect = document.getElementById('address_country');
        const provinceContainer = document.getElementById('address_province_container');
        const provinceSelect = document.getElementById('address_province');
        const calculateButton = document.querySelector('.get-rates');
        const wrapper = document.getElementById(_config.wrapperId);

        // Initialize provinces on page load
        if (countrySelect && provinceSelect) {
          const defaultCountry = countrySelect.dataset.default || '';
          const defaultProvince = provinceSelect.dataset.default || '';
          if (defaultCountry) {
            if (Countries[defaultCountry] && Countries[defaultCountry].provinces) {
              provinceContainer.style.display = 'block';
              countrySelect.value = defaultCountry;
              _populateProvinces(defaultCountry, provinceSelect, defaultProvince);
              Countries.updateProvinceLabel(defaultCountry);
            } else {
              provinceContainer.style.display = 'none';
            }
          }
        }

        // Update provinces on country change
        if (countrySelect) {
          countrySelect.addEventListener('change', function() {
            const country = this.value;
            document.getElementById('address_zip').value = "";
            if (Countries[country] && Countries[country].provinces) {
              provinceContainer.style.display = 'block';
              _populateProvinces(country, provinceSelect);
              Countries.updateProvinceLabel(country);
            } else {
              provinceContainer.style.display = 'none';
              provinceSelect.innerHTML = '';
            }
          });
        }

        if (calculateButton) {
          calculateButton.addEventListener('click', function() {
            this.value = _config.submitButtonDisabled;
            this.disabled = true;
            if (wrapper) wrapper.innerHTML = '';
            
            const data = {
              shipping_address: {
                country: document.getElementById('address_country').value,
                province: provinceSelect ? provinceSelect.value : '',
                zip: document.getElementById('address_zip').value
              }
            };

            fetch('/cart/shipping_rates.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
              .then(response => {
                if (!response.ok) {
                  return response.json().then(err => {
                    throw new Error(err.message || 'Error calculating shipping rates.');
                  });
                }
                return response.json();
              })
              .then(data => {
                _render({ success: true, rates: data.shipping_rates || [] });
              })
              .catch(error => {
                _render({ success: false, error: error.message });
              })
              .finally(() => {
                calculateButton.value = _config.submitButton;
                calculateButton.disabled = false;
              });
          });
        }
      });
    }
  };
})();

Shopify.Cart.ShippingCalculator.show({
  submitButton: "Calculate Shipping",
  submitButtonDisabled: "Calculating...",
  customerIsLoggedIn: false,
  moneyFormat: ""
});